import { useBunja } from 'bunja/react';
import { isEmpty } from 'es-toolkit/compat';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { useSpotHoldings } from '@flipster/features/src/shared/spot-holdings/state';
import { Col, Table, TableHeader } from '@flipster/ui/Table';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import PurchasedPositionRow from './PurchasedPositionRow';
import styles from './positionTable.module.scss';

interface Props {
  showAllSymbol: boolean;
}

const PurchasedPositionTable = ({ showAllSymbol }: Props) => {
  const transAssets = useTranslations('Assets.r250401');
  const transTrade = useTranslations('Trade.r250401');
  const { symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const symbolInfo = useAtomValue(symbolInfoAtom);
  const { holdings } = useSpotHoldings();

  const symbolKey = symbolInfo?.baseCurrency;
  const positions = holdings
    .filter(([key]) => {
      const isSpotSymbol = showAllSymbol ? true : symbolKey === key;
      return isSpotSymbol;
    })
    .map(([key, value]) => ({ currency: key, ...value }));

  const hidePnl = positions.some((p) => !p.pnl || !p.pnlPct);

  const columns: Col[] = [
    { key: 'pair', title: transTrade('Spot_usdt_pairs'), minWidth: 90 },
    { key: 'amount', title: transTrade('Amount'), minWidth: 100 },
    ...(hidePnl ? [] : [{ key: 'pnl', title: transAssets('Pnl'), minWidth: 100 } satisfies Col]),
  ];

  if (isEmpty(positions)) return <p className={styles.noData}>{transAssets('All_your_crypto_holdings_show_here')}</p>;

  return (
    <Table
      className={styles.table}
      tHeader={<TableHeader columns={columns} />}
      items={positions}
      renderRow={(position) => <PurchasedPositionRow key={position.currency} item={position} showPnl={!hidePnl} />}
      withHover
    />
  );
};

export default PurchasedPositionTable;
